exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table {\n  background-color: white; }\n  .table tr.customer {\n    cursor: pointer; }\n\n.loading-codes {\n  background-color: aliceblue;\n  height: 100%;\n  left: 0;\n  opacity: 0.6;\n  position: fixed;\n  text-align: center;\n  top: 0;\n  width: 100%; }\n  .loading-codes img {\n    max-height: 150px;\n    margin-top: 16%; }\n  .loading-codes p {\n    font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/usuarios-ganalottodo/ganalottodo-users.component.scss
// module id = ../../../../../src/app/components/usuarios-ganalottodo/ganalottodo-users.component.scss
// module chunks = main